import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Typography } from '@material-ui/core'
import { FormattedMessage, injectIntl } from 'react-intl'
import Paper from '@material-ui/core/Paper'
import 'styles/app/apps/seaLice/reports.scss'
import cn from 'classnames'
import NoData from 'components/common/NoData/NoData'
import WidgetContainer from 'components/Apps/WidgetContainer'
import messages from '../translate'

class CountBarriosSummary extends Component {
  renderReports = data => {
    const getColorIndicator = elem =>
      cn('result', {
        high: elem <= 0,
        low: elem > 0,
      })

    return data.map(({ name, avg, diff }) => (
      <Paper key={`summary_${name}`} className="summary-item" elevation={2}>
        <Typography className="count" variant="h4">
          {`${avg}`}
        </Typography>
        <div className="name">
          <FormattedMessage {...messages[name]} />
        </div>
        <div className="diff">
          <span className={getColorIndicator(diff)}>{`${diff}`}</span>
          <FormattedMessage {...messages.previous} />
        </div>
      </Paper>
    ))
  }

  // eslint-disable-next-line max-statements
  getActiveBarrioData = (sitesData, activeBarrio) => {
    let currentWeek = {
      total_count: null,
      juveniles: null,
      mobile_adult: null,
      pregnant_female: null,
    }

    let previousWeek = {
      total_count: null,
      juveniles: null,
      mobile_adult: null,
      pregnant_female: null,
    }

    let cWTotalCount = 0
    let cWJuveniles = 0
    let cWMobile = 0
    let cWFemale = 0
    let pWTotalCount = 0
    let pWJuveniles = 0
    let pWMobile = 0
    let pWFemale = 0
    let cWTotalCountI = 0
    let cWJuvenilesI = 0
    let cWMobileI = 0
    let cWFemaleI = 0
    let pWTotalCountI = 0
    let pWJuvenilesI = 0
    let pWMobileI = 0
    let pWFemaleI = 0
    // eslint-disable-next-line no-param-reassign
    sitesData = sitesData.toArray()

    for (const k in sitesData) {
      if (sitesData.hasOwnProperty(k)) {
        const data = sitesData[k]
        const neibor = data.neighborhood_id

        if (neibor === activeBarrio) {
          const siteWeeks = data.weeks
          const _currentWeek = { ...siteWeeks[siteWeeks.length - 1] }
          const _previousWeek = { ...siteWeeks[siteWeeks.length - 2] }
          currentWeek = _currentWeek
          previousWeek = _previousWeek

          if (_currentWeek.total_count !== null) {
            cWTotalCount += _currentWeek.total_count
            cWTotalCountI += 1
          }
          if (_currentWeek.juveniles !== null) {
            cWJuveniles += _currentWeek.juveniles
            cWJuvenilesI += 1
          }
          if (_currentWeek.mobile_adult !== null) {
            cWMobile += _currentWeek.mobile_adult
            cWMobileI += 1
          }
          if (_currentWeek.pregnant_female !== null) {
            cWFemale += _currentWeek.pregnant_female
            cWFemaleI += 1
          }
          if (_previousWeek.total_count !== null) {
            pWTotalCount += _previousWeek.total_count
            pWTotalCountI += 1
          }
          if (_previousWeek.juveniles !== null) {
            pWJuveniles += _previousWeek.juveniles
            pWJuvenilesI += 1
          }
          if (_previousWeek.mobile_adult !== null) {
            pWMobile += _previousWeek.mobile_adult
            pWMobileI += 1
          }
          if (_previousWeek.pregnant_female !== null) {
            pWFemale += _previousWeek.pregnant_female
            pWFemaleI += 1
          }
        }
      }
    }

    currentWeek.total_count = cWTotalCount / cWTotalCountI
    currentWeek.juveniles = cWJuveniles / cWJuvenilesI
    currentWeek.mobile_adult = cWMobile / cWMobileI
    currentWeek.pregnant_female = cWFemale / cWFemaleI
    previousWeek.total_count = pWTotalCount / pWTotalCountI
    previousWeek.juveniles = pWJuveniles / pWJuvenilesI
    previousWeek.mobile_adult = pWMobile / pWMobileI
    previousWeek.pregnant_female = pWFemale / pWFemaleI

    return { currentWeek, previousWeek }
  }

  getUnitName = () => {
    const { activeBarrios } = this.props
    const barriosList = this.props.barriosList.toArray()
    let barrioName = null

    for (const k in barriosList) {
      if (
        barriosList.hasOwnProperty(k) &&
        barriosList[k].id === activeBarrios
      ) {
        barrioName = barriosList[k].name
        break
      }
    }

    return barrioName
  }

  getItem = (title, current, previous) => ({
    name: title,
    avg:
      // eslint-disable-next-line no-restricted-globals
      current === null || isNaN(current)
        ? 'N/A'
        : Math.round(current * 100) / 100,
    diff:
      // eslint-disable-next-line no-restricted-globals
      current === null || isNaN(current)
        ? 'N/A'
        : Math.round((current - previous) * 100) / 100,
  })

  getData = () => {
    const { activeBarrios, sitesData } = this.props
    const { currentWeek, previousWeek } = this.getActiveBarrioData(
      sitesData,
      activeBarrios,
    )

    return [
      this.getItem(
        'gravidFemales',
        currentWeek.pregnant_female,
        previousWeek.pregnant_female,
      ),
      this.getItem(
        'mobileAdults',
        currentWeek.mobile_adult,
        previousWeek.mobile_adult,
      ),
      this.getItem('juvenile', currentWeek.juveniles, previousWeek.juveniles),
      this.getItem(
        'totalSeaLice',
        currentWeek.total_count,
        previousWeek.total_count,
      ),
    ]
  }

  render() {
    const {
      sitesData,
      intl: { formatMessage },
    } = this.props
    const data = this.getData()

    if (sitesData.toArray().length === 0) {
      return <NoData />
    }

    return (
      <WidgetContainer
        name={{
          start: this.getUnitName(),
          end: `${formatMessage(messages.countSummary)} - (Avg.)`,
        }}>
        <div className="summary-count">{this.renderReports(data)}</div>
      </WidgetContainer>
    )
  }
}

export default connect(
  state => ({
    sitesData: state.getIn(['seaLice', 'sitesData']),
    barriosList: state.getIn(['seaLice', 'barriosList']),
    activeBarrios: state.getIn(['seaLice', 'activeBarrios']),
  }),
  null,
)(injectIntl(CountBarriosSummary))
